import { render, staticRenderFns } from "./organization-statistics.vue?vue&type=template&id=96d2d4aa&"
import script from "./organization-statistics.vue?vue&type=script&lang=js&"
export * from "./organization-statistics.vue?vue&type=script&lang=js&"
import style0 from "./organization-statistics.vue?vue&type=style&index=0&id=96d2d4aa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports